module.exports = "<div class=\"link-text-area\" (click)=\"handleTextAreaClick($event)\">\n    <div #editableContent\n        [attr.contenteditable]=\"contentEditable\"\n        (input)=\"handleInput($event)\" \n        [innerHTML]=\"formattedText\"        \n        (dblclick)=\"handleLinkClick($event)\"\n        (keydown)=\"handleKeyDown($event)\"\n    >\n    </div>\n    <label #labelForEditableContent>{{labelText}}</label>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/helper-components/link-text-area.component.html
// module id = 560
// module chunks = 1